import { useNavigate as realUseNavigate } from "react-router";
import { isLiveEnvironment } from "../common/testHelpers";
/* eslint-disable no-shadow-restricted-names */
export var useNavigate = function () {
    return isLiveEnvironment()
        ? realUseNavigate()
        : function (toConsole) { return console.log("navigateTo:", toConsole); };
};
/* eslint-enable no-shadow-restricted-names */
